import script from "./VideoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPage.vue?vue&type=script&setup=true&lang=js"

import "./VideoPage.vue?vue&type=style&index=0&id=96a3ac62&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96a3ac62"]])

export default __exports__